import React, { Component } from 'react'

import moment from 'moment'

import { isMobile } from 'react-device-detect'

var Datetime = require('react-datetime')

class InputDate extends Component
{

    constructor(props) {
        super(props)

        moment.locale('fr')

        this.state = {}
    }

    isValidDate(e) {
        if (this.props.isValidDate) {
            return this.props.isValidDate(e)
        }

        return true
    }

    render() {
        if (isMobile) {
            return (
                <span style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}>
          <input type="date" style={{ minWidth: '150px' }} min={moment().format("YYYY-MM-DD")} onChange={(e) => this.props.onChange(moment(e.target.value))}
                 value={this.props.value ? this.props.value.format("YYYY-MM-DD") : ''}/>
          <i className="icon-calendar icons" style={{ marginLeft: '5px', verticalAlign: 'middle' }}></i>
        </span>
            )
        } else {
            return (
                <span style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}>
                  <Datetime
                      className={"datetime " + this.props.className}
                      locale="fr" closeOnSelect={true}
                      timeFormat={false}
                      isValidDate={this.isValidDate.bind(this)}
                      onChange={(e) => this.props.onChange(e)}
                      value={this.props.value}
                      readOnly={true}
                      inputProps={{
                          readOnly: true,
                          style: { cursor: "pointer" }
                      }}
                  />
                  <i className="icon-calendar icons" style={{ marginLeft: '5px' }}></i>
                </span>
            )
        }
    }
}

export default InputDate
